export default function Footer() {
  return (
    <footer className="bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="flex flex-col items-center gap-6 sm:gap-8">
          <img 
            src="/images/logo2.png" 
            alt="GIO Estética Avançada de Americana" 
            className="h-16 sm:h-28 w-auto"
          />
          
          <div className="flex flex-col items-center gap-3 text-gray-600 text-center">
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-[#E91E63]"></i>
              <span className="text-base font-semibold">GIO Estética Avançada de Americana</span>
            </div>
            <span className="text-xs sm:text-sm">R. das Paineiras, 304 - Jardim São Paulo, Americana - SP, 13468-060</span>
            
            <a 
              href="https://wa.me/5519978232002?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20agendar%20minha%20avaliação%20gratuita."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#E91E63] hover:text-[#C2185B] transition-colors font-semibold cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span className="text-sm sm:text-base">(19) 97823-2002</span>
            </a>
          </div>

          <div className="text-sm text-center space-y-1">
            <p className="text-gray-500">© 2026 Todos os direitos reservados.</p>
            <a 
              href="https://m4.digital" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#E91E63] transition-colors cursor-pointer block"
            >
              Desenvolvido por M4 Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
